import { ButtonBase } from '@patrianna/core-components'
import type { ButtonBaseProps } from '@patrianna/core-components'
import cx from 'classnames'
import type { ReactNode } from 'react'

import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

export type ButtonPropsType = Omit<ButtonBaseProps, 'color'>

type Props = {
  children?: ReactNode
  disabled?: boolean
  color?: SupportedCurrencies
  className?: string
  loading?: boolean
} & ButtonPropsType

function Button(props: Props) {
  const { color, children, className, variant, loading, ...rest } = props
  const themeName = color || 'default'

  return (
    <ButtonBase
      {...rest}
      onClick={props?.onClick}
      className={cx(`${classes.root} ${className} ${!rest.disabled ? classes[themeName] : classes.disabled}`, {
        [classes.loading]: loading,
      })}
      variant={variant || 'contained'}
    >
      {children}
    </ButtonBase>
  )
}

export default Button
